import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import withRouter from '../../../../lib/router/withRouter';
import { difference, filter, includes } from 'lodash';
import SearchInactiveWidgetModal from '../../../../views/widget/common/modal/SearchInactiveWidgetModal';
import withModal from '../../../../lib/hoc/withModal';
import { widgetActions } from '../../../../store/modules/widget';
import { INVALID_MINIMUM_SEARCH_WORD_MESSAGE } from '../../../../constants/service/common/utilConstants';
import { HOME_TYPE, WIDGET_STATUS, WIDGET_TYPE } from '../../../../constants/service/app/widgetConstants';
import { WIDGET_SEARCH_KEYWORD } from '../../../../store/modules/widget/models';
import { asyncSimpleModal, checkIsNonSelectedList } from '../../../../lib/common';
import { INVALID_REQUIRED_SELECT_WIDGET_MESSAGE } from '../../../../constants/service/invalidMsg/widgetInvalidMsg';

class SearchInactiveWidgetModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchData: {
        searchKeyword: WIDGET_SEARCH_KEYWORD,
      },
      /**
       *  선택된 위젯 id 리스트
       */
      selectedWidgetIdList: [],
    };
  }

  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { data } = this.props;
    const { searchOption, pagination, excludeWidgetIdList } = data;

    this.getList({
      searchOption,
      pagination,
      excludeWidgetIdList,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (option) => {
    const { getWidgetInactiveList, data } = this.props;
    const { selectedWidgetIdList } = this.state;
    const { searchOption, pagination, excludeWidgetIdList } = data;

    /**
     * 검색어 유효성 체크
     */
    if (option.searchOption) {
      /**
       * 두 글자 이상
       */
      const { searchKeyword } = option.searchOption;
      if (searchKeyword && searchKeyword.text && (searchKeyword.text === '' || searchKeyword.text.length < 2)) {
        message.error(INVALID_MINIMUM_SEARCH_WORD_MESSAGE);
        return;
      }
    }

    /**
     * 선택된 위젯이 있을 경우,
     * 확인 모달을 보여주면서,
     * 페이지 이동 또는 검색을 하는 경우,
     * 선택된 위젯이 해제가 된다는 메시지를 보여줌.
     */
    if (selectedWidgetIdList.length) {
      const confirmResult = await asyncSimpleModal({
        type: 'confirm',
        title: '선택된 위젯 해제',
        message: '검색 또는 페이지를 변경 할 경우에는\n 선택된 위젯이 해제됩니다.',
      });

      if (!confirmResult) return;

      this.setData({
        name: 'selectedWidgetIdList',
        value: [],
      });
    }
    /*
     메인 페이지 관리에서만 isProductRecommend 값을 true로 보내도록 관련 로직과 파라미터를 추가
    */

    getWidgetInactiveList({
      searchOption,
      pagination,
      excludeWidgetIdList,
      isProductRecommend: !location.pathname.includes('/sub/'),
      ...option,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'searchInactiveWidgetModal', value: false });
  };

  /**
   * 검색 데이터 변경
   */
  onChangeKeyword = (searchKeyword) => {
    this.setState({
      ...this.state,
      searchData: {
        searchKeyword,
      },
    });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  /**
   * 비활성 위젯을 노출줄인 위젯으로 추가하기
   */
  onSubmit = async () => {
    const { setData, pageWidgetList, data } = this.props;
    const { selectedWidgetIdList } = this.state;
    /**
     * 선택된 위젯이 있는지 체크
     */
    const isSelected = checkIsNonSelectedList(selectedWidgetIdList, INVALID_REQUIRED_SELECT_WIDGET_MESSAGE);
    if (!isSelected) return;

    /**
     * 중복된 위젯 리스트 제거하기
     */
    const pageWidgetIdList = pageWidgetList.map((widget) => widget.id);
    const targetWidgetIdList = difference(selectedWidgetIdList, pageWidgetIdList);

    /**
     * 추가할 위젯 리스트 만들기
     */
    let addWidgetList = filter(data.list, (widget) => includes(targetWidgetIdList, widget.id));
    addWidgetList = addWidgetList.map((widget) => ({
      ...widget,
      status: WIDGET_STATUS.ACTIVE,
      isEdit: true,
    }));

    let updatedWidgetList = [];

    const eventWidgetList = addWidgetList.filter((item) => item.widgetType === WIDGET_TYPE.EVENT);
    if (eventWidgetList.length > 1) {
      await asyncSimpleModal({
        type: 'error',
        title: '위젯 추가',
        message: '기획전 위젯은 1개씩만 추가가 가능합니다.',
      });
      return;
    }

    if (data.homeType === HOME_TYPE.MAIN) {
      const newEventWidget = eventWidgetList[0];
      const otherWidgetList = newEventWidget
        ? addWidgetList.filter((item) => item.id !== newEventWidget.id)
        : addWidgetList;
      const [firstWidget, emptyRow, ...restWidgetList] = pageWidgetList;

      if (firstWidget.widgetType === WIDGET_TYPE.EVENT && newEventWidget) {
        const confirmResult = await asyncSimpleModal({
          type: 'confirm',
          title: '기획전 위젯 추가',
          message:
            '기획전 위젯이 존재히며,\n 확인을 누를 시 기존 기획전 위젯은 사라지게 됩니다.\n 그래도 진행하시겠습니까?',
        });
        if (!confirmResult) return;

        updatedWidgetList = [newEventWidget, emptyRow, ...otherWidgetList, ...restWidgetList];
      }

      if (firstWidget.widgetType === WIDGET_TYPE.EVENT && !newEventWidget) {
        updatedWidgetList = [firstWidget, emptyRow, ...otherWidgetList, ...restWidgetList];
      }

      if (firstWidget.widgetType !== WIDGET_TYPE.EVENT && newEventWidget) {
        updatedWidgetList = [newEventWidget, emptyRow, ...otherWidgetList, ...pageWidgetList.toSpliced(1, 1)];
      }

      if (firstWidget.widgetType !== WIDGET_TYPE.EVENT && !newEventWidget) {
        updatedWidgetList = [firstWidget, emptyRow, ...otherWidgetList, ...restWidgetList];
      }

      updatedWidgetList = updatedWidgetList.map((widget, idx) => {
        const { rowCanDrag, ...widgetWithoutRowCanDrag } = widget;
        return idx === 0 || idx === 1 ? { ...widgetWithoutRowCanDrag, rowCanDrag: false } : widgetWithoutRowCanDrag;
      });
    } else {
      // 서브 페이지
      if (pageWidgetList[0] && pageWidgetList[0].widgetType === WIDGET_TYPE.EVENT) {
        // 첫번째 위젯이 기획전위젯이 있을 경우 2번째부터 위젯을 추가하도록함
        updatedWidgetList = [pageWidgetList[0], ...addWidgetList, ...pageWidgetList.slice(1)];
      } else {
        updatedWidgetList = [...addWidgetList, ...pageWidgetList];
      }
      if (addWidgetList.length) {
        // 새롭게 추가되는 위젯이 있을 경우에는 기존의 위젯들이 순서가 변경이 되므로 편집여부를 활성시킴
        updatedWidgetList = updatedWidgetList.map((item) => ({
          ...item,
          isEdit: true,
        }));
      }
    }

    setData({
      path: ['pageWidgetList', 'widgetList', 'list'],
      value: updatedWidgetList,
    });

    this.closeModal();
  };

  render() {
    return (
      <SearchInactiveWidgetModal
        {...this.state}
        {...this.props}
        onChangeKeyword={this.onChangeKeyword}
        setData={this.setData}
        getList={this.getList}
        onSubmit={this.onSubmit}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.widget.searchInactiveWidgetModal.isOpen,
    data: state.widget.searchInactiveWidgetModal.data,
    pageWidgetList: state.widget.pageWidgetList.widgetList.list,
  };
};

const mapDispatchToProps = {
  setData: widgetActions.setData,
  toggleModal: widgetActions.toggleModal,
  getWidgetInactiveList: widgetActions.getWidgetInactiveList,
  getWidgetPreviewData: widgetActions.getWidgetPreviewData,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withModal()(SearchInactiveWidgetModalContainer)),
);
